import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { auth } from '../services/api';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      // Verifica se cookie de autenticação é válido
      await auth.me();
      setIsAuthenticated(true);
    } catch (error) {
      // Cookie inválido/expirado = BLOQUEIA
      localStorage.removeItem('user');
      localStorage.removeItem('isAdminAuthenticated');
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  // Enquanto verifica, mostra loading
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          <p className="mt-4 text-gray-600">Verificando autenticação...</p>
        </div>
      </div>
    );
  }

  // Se não autenticado, REDIRECIONA para login
  if (!isAuthenticated) {
    return <Navigate to="/admin-login" replace />;
  }

  // Se autenticado, LIBERA acesso
  return <>{children}</>;
}
